import * as Actions from '../../actions';

const initialState = {
	list: [],
	hash: null,
	connectServ: 'unk'
};
const providersReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_PROVIDERS: {
			return {
				...state,
				list: action.payload
			};
		}
		case Actions.SET_HASH: {
			return {
				...state,
				hash: action.payload
			};
		}
		case Actions.SET_CONECT: {
			return {
				...state,
				connectServ: action.payload
			};
		}
		case Actions.SET_CHANGE_DB_CLUSTERS: {
			return {
				...state,
				changedDbClusters: action.payload
			};
		}
		case Actions.SET_CHANGE_DB_NODES: {
			return {
				...state,
				changedDbNodes: action.payload
			};
		}
		case Actions.SET_CHANGE_DB_QUEUEDJOB: {
			return {
				...state,
				changedDbQueuedjobs: action.payload
			};
		}
		case Actions.SET_CHANGE_DB_CLUSTERHEALTH: {
			return {
				...state,
				changedDbClusterHealth: action.payload
			};
		}
		case Actions.SET_CHANGE_DB_COMMISSIONEDMACHINES: {
			return {
				...state,
				changedDbCommissionedMachines: action.payload
			};
		}
		case Actions.CLEAR_PROVIDER_REDUCER: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default providersReducer;
